/* tslint:disable */
/* eslint-disable */
/**
 * Melco Identity APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IdentityMelcoModelsCustomWarning,
    IdentityMelcoModelsCustomWarningFromJSON,
    IdentityMelcoModelsCustomWarningFromJSONTyped,
    IdentityMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface IdentityMelcoModelsUserPackageListItem
 */
export interface IdentityMelcoModelsUserPackageListItem {
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsUserPackageListItem
     */
    user_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsUserPackageListItem
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsUserPackageListItem
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsUserPackageListItem
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsUserPackageListItem
     */
    credits?: number;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsUserPackageListItem
     */
    remaining_credits?: number;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsUserPackageListItem
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsUserPackageListItem
     */
    melco_payment_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsUserPackageListItem
     */
    product_code?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityMelcoModelsUserPackageListItem
     */
    is_auto_renew?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsUserPackageListItem
     */
    purchase_type?: number;
    /**
     * 
     * @type {Array<IdentityMelcoModelsCustomWarning>}
     * @memberof IdentityMelcoModelsUserPackageListItem
     */
    warning_list?: Array<IdentityMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {Date}
     * @memberof IdentityMelcoModelsUserPackageListItem
     */
    start_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof IdentityMelcoModelsUserPackageListItem
     */
    end_date?: Date | null;
}

export function IdentityMelcoModelsUserPackageListItemFromJSON(json: any): IdentityMelcoModelsUserPackageListItem {
    return IdentityMelcoModelsUserPackageListItemFromJSONTyped(json, false);
}

export function IdentityMelcoModelsUserPackageListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityMelcoModelsUserPackageListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user_id': !exists(json, 'user_id') ? undefined : json['user_id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'price': !exists(json, 'price') ? undefined : json['price'],
        'credits': !exists(json, 'credits') ? undefined : json['credits'],
        'remaining_credits': !exists(json, 'remaining_credits') ? undefined : json['remaining_credits'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'melco_payment_id': !exists(json, 'melco_payment_id') ? undefined : json['melco_payment_id'],
        'product_code': !exists(json, 'product_code') ? undefined : json['product_code'],
        'is_auto_renew': !exists(json, 'is_auto_renew') ? undefined : json['is_auto_renew'],
        'purchase_type': !exists(json, 'purchase_type') ? undefined : json['purchase_type'],
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(IdentityMelcoModelsCustomWarningFromJSON)),
        'start_date': !exists(json, 'start_date') ? undefined : (json['start_date'] === null ? null : new Date(json['start_date'])),
        'end_date': !exists(json, 'end_date') ? undefined : (json['end_date'] === null ? null : new Date(json['end_date'])),
    };
}

export function IdentityMelcoModelsUserPackageListItemToJSON(value?: IdentityMelcoModelsUserPackageListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_id': value.user_id,
        'name': value.name,
        'description': value.description,
        'price': value.price,
        'credits': value.credits,
        'remaining_credits': value.remaining_credits,
        'code': value.code,
        'melco_payment_id': value.melco_payment_id,
        'product_code': value.product_code,
        'is_auto_renew': value.is_auto_renew,
        'purchase_type': value.purchase_type,
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(IdentityMelcoModelsCustomWarningToJSON)),
        'start_date': value.start_date === undefined ? undefined : (value.start_date === null ? null : value.start_date.toISOString()),
        'end_date': value.end_date === undefined ? undefined : (value.end_date === null ? null : value.end_date.toISOString()),
    };
}


